export class ErrorMessageResource {
    public static DUPLICATED_CODE = 'financial-group:duplicated_group_code_error';
}